import { APISettings } from "../../config/ApiSettings";
import { BaseAPI } from "./baseApi";
const baseUrl = new APISettings().getApiURL();

class WorkflowStatusActionRoleApi<WorkflowStatusActionRole> extends BaseAPI {
    public getByRoleId: (id: number) => Promise<WorkflowStatusActionRole[]> = async(id: number) => {
        return (await BaseAPI.axios.get(`${baseUrl}/WorkflowStatusActionRole/GetByRoleId/${id}`)).data.output;
    }

    public getByRoleName: (name: string) => Promise<WorkflowStatusActionRole[]> = async(name: string) => {
        return (await BaseAPI.axios.get(`${baseUrl}/WorkflowStatusActionRole/GetByRoleName/${name}`)).data.output;
    }
}

export const workflowStatusActionRoleApi = new WorkflowStatusActionRoleApi();